// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17vS8","content":"styles_content__2b_GB"};